import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  menu: {
    // marginTop: 35
    '& .MuiPaper-root': {
      borderRadius: '20px', // Estilo de "pílula" moderno
      boxShadow: theme.shadows[3],
      padding: '2px 8px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_300.main
          : theme.palette.common.white
    }
  },
  emojiButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
    borderRadius: '50%',
    padding: '2px',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.gray_100.main
    }
  },
  emojiButtonMenu: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '2px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      color: theme.palette.blue_300.main,
      transform: 'rotate(90deg)', // Efeito sutil no botão de +
      transition: 'all 0.3s'
    }
  },
  flexContainer: {
    display: 'flex',
    gap: '6px',
    padding: '2px 6px',
    alignItems: 'center',
    fontFamily: 'Noto Color Emoji, sans-serif'
    // flexWrap: 'wrap',
    // justifyContent: 'space-around'
  }
}))
